import { render, staticRenderFns } from "./ExpandedModel.vue?vue&type=template&id=67744218&scoped=true"
import script from "./ExpandedModel.vue?vue&type=script&lang=js"
export * from "./ExpandedModel.vue?vue&type=script&lang=js"
import style0 from "./ExpandedModel.vue?vue&type=style&index=0&id=67744218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67744218",
  null
  
)

export default component.exports